import { authenticatedFetch, authenticatedPost } from './request';

export default async function getCity(setErrorMessage,payload) {
    const onError = () => setErrorMessage('No se puede obtener las ciudades.');
    return await authenticatedFetch('/cities/getList', onError);
    // return await authenticatedPost('/master/get-list',onError,payload)
}
